import React from 'react';
import extended from './extendedFeat';

const Extended = () => {

    const renderExtended = () => extended.map(feature => {
        return (
            <div key={feature.id} >
                <div className='boxes-extended' >
                    <h5 className='ext-h5'>{feature.name}</h5>
                    <p className='ext-p' >{feature.content}</p>
                </div>
            </div>
        );
    })

    return (
        <div>
            <div className='spacer'></div>
            <h2>Extended Features</h2>
            <div id='extended-feature'>
                {renderExtended()}
            </div>
        </div>
    );
};

export default Extended;